module.exports = __webpack_public_path__ + "img/book_icon.5348b003.svg";